import React from 'react';
import './confirmation-modal.scss';

export default function ConfirmationModal({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirmar ação", 
  message = "Tem certeza que deseja continuar?",
  confirmText = "Confirmar",
  cancelText = "Cancelar",
  type = "danger" // danger, warning, info
}) {
  if (!isOpen) return null;

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className="confirmation-modal-backdrop" onClick={handleBackdropClick}>
      <div className="confirmation-modal">
        <div className="confirmation-modal__header">
          <h3 className="confirmation-modal__title">{title}</h3>
          <button 
            className="confirmation-modal__close"
            onClick={onClose}
            aria-label="Fechar"
          >
            ×
          </button>
        </div>
        
        <div className="confirmation-modal__body">
          <div className={`confirmation-modal__icon confirmation-modal__icon--${type}`}>
            {type === 'danger' && '⚠️'}
            {type === 'warning' && '⚠️'}
            {type === 'info' && 'ℹ️'}
          </div>
          <p className="confirmation-modal__message">{message}</p>
        </div>
        
        <div className="confirmation-modal__footer">
          <button 
            className="btn btn--secondary"
            onClick={onClose}
          >
            {cancelText}
          </button>
          <button 
            className={`btn btn--${type}`}
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}
